import Input from '@repo/input';
import { IoAdd, IoClose } from 'react-icons/io5';
import './CompositionInput.css';

export interface CompositionItem {
    value: string;
    count: number;
}

export interface CompositionInputProps {
    value?: CompositionItem[];
    onChange?: (value: CompositionItem[]) => void;
    error?: string;
    label?: string;
    description?: string;
}

const defaultItem: CompositionItem = { value: '', count: 0 };

export default function CompositionInput({
    value = [defaultItem],
    onChange,
    error,
    label = 'Состав',
    description,
}: CompositionInputProps) {
    const items = value.length > 0 ? value : [defaultItem];

    const updateItems = (newItems: CompositionItem[]) => {
        onChange?.(newItems);
    };

    const handleValueChange = (index: number, valueStr: string) => {
        const newItems = [...items];
        newItems[index] = { ...newItems[index], value: valueStr };
        updateItems(newItems);
    };

    const handleCountChange = (index: number, countStr: string) => {
        const count = countStr === '' ? 0 : Math.max(0, parseInt(countStr, 10) || 0);
        const newItems = [...items];
        newItems[index] = { ...newItems[index], count };
        updateItems(newItems);
    };

    const handleAdd = () => {
        updateItems([...items, { value: '', count: 0 }]);
    };

    const handleRemove = (index: number) => {
        if (items.length > 1) {
            updateItems(items.filter((_, i) => i !== index));
        }
    };

    return (
        <div className="composition-input">
            <label>{label}</label>
            {description && <p className="composition-input__description">{description}</p>}
            {items.map((item, index) => (
                <div key={index} className="composition-input-row">
                    <div className="form-group composition-input-row__name">
                        <Input
                            placeholder="Название (например: Розы)"
                            value={item.value}
                            onChange={(e) => handleValueChange(index, e.target.value)}
                            error={error && !item.value.trim() ? true : undefined}
                        />
                    </div>
                    <div className="form-group composition-input-row__count">
                        <Input
                            type="number"
                            min={0}
                            step={1}
                            placeholder="шт"
                            value={item.count === 0 ? '' : item.count}
                            onChange={(e) => handleCountChange(index, e.target.value)}
                            error={error && !(item.count > 0) ? true : undefined}
                            aria-label="Количество"
                        />
                    </div>
                    {items.length > 1 && (
                        <button
                            type="button"
                            className="composition-input__icon-btn composition-input__icon-btn--remove"
                            onClick={() => handleRemove(index)}
                            aria-label="Удалить позицию"
                        >
                            <IoClose size={16} aria-hidden />
                        </button>
                    )}
                    {index === items.length - 1 && (
                        <button
                            type="button"
                            className="composition-input__icon-btn composition-input__icon-btn--add"
                            onClick={handleAdd}
                            aria-label="Добавить позицию"
                        >
                            <IoAdd size={16} aria-hidden />
                        </button>
                    )}
                </div>
            ))}
            {error && <span className="error-message">{error}</span>}
        </div>
    );
}
